import React from "react";
import PropTypes from "prop-types";

// import { formatDateTime } from "base/utils";
import { Utils } from "widgets/datetime";

import styles from "./style.css";

const { formatToLocale } = Utils;
export function DateTime(props) {
  const { value } = props;
  const formattedDateTime = formatToLocale(value, true, true);
  return <div className={`${styles.text} ellipsis`}>{formattedDateTime}</div>;
}

DateTime.propTypes = {
  value: PropTypes.string
};
